<template>
  <div>
    <el-dialog
      title="Edit channel"
      :visible="dialog_edit"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setDialogEdit(false)"
    >
      <div class="flex-center">
        <img :src="channel.image_url" class="profile-photo">
      </div>
      <p>Channel title: <strong>{{channel.title}}</strong><br>
        Channel ID: <strong>{{channel.channelId}}</strong></p>
      <el-form label-position="top">
        <!-- Label select dropdown with multiple selection -->
        <el-form-item label="Select Labels" prop="labels">
          <el-select
            v-model="selectedLabels"
            multiple
            placeholder="Select labels"
            @change="handleLabelChange"
          >
            <!-- Add a "Select All" option -->
            <el-option
              :key="'selectAll'"
              :label="'Select All'"
              :value="0"
              :disabled="labels.length === 0"
            />
            <el-option
              v-for="label in labels"
              :key="label.id"
              :label="label.name"
              :value="label.id"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <!-- Footer with Save button -->
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      selectedLabels: [] // Array to hold multiple selected labels
    }
  },
  computed: {
    ...mapState('youtubeWhitelist', ['dialog_edit', 'loading', 'labels','channel'])
  },
  watch: {
    channel: {
      handler(newChannel) {
        if (newChannel && newChannel.label_ids) {
          // Check if label_ids is a string before parsing
          this.selectedLabels = typeof newChannel.label_ids === 'string'
              ? JSON.parse(newChannel.label_ids)
              : newChannel.label_ids;
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getLabels() // Fetch labels when component is mounted
  },
  methods: {
    ...mapActions('youtubeWhitelist', ['edit', 'getLabels']),
    ...mapMutations('youtubeWhitelist', ['setDialogEdit']),

    submit() {
      if (!this.channel || this.selectedLabels.length === 0) {
        this.$message.error('Please fill out both fields before submitting.')
        return
      }

      // Call the insert method and pass the channel and selected labels
      this.edit({ channelId: this.channel.channelId, labelIds: this.selectedLabels })
      this.setDialogEdit(false)
      this.selectedLabels = [] // Clear the selected labels
    },

    // Handle changes in the selected labels
    handleLabelChange(selectedLabels) {
      if (selectedLabels.includes(0)) {
        // If 'Select All' was clicked, select all labels
        // Check if "Select All" is already in the selected list
        if (selectedLabels.length === this.labels.length + 1) {
          // If "Select All" is selected with all labels, deselect all
          this.selectedLabels = []
        } else {
          // Otherwise, select all labels
          this.selectedLabels = this.labels.map(label => label.id)
        }
      }
    }
  }
}
</script>
